import { GetStaticProps } from 'next';
import { ITSTaxonomyProductQueryVars } from '../utils/typesense/types/taxonomy';
import TSTaxonomy from '../utils/typesense/taxonomy';
import TaxonomyItemPage from '../components/content/TaxonomyItemPage';
import TSPage from '../utils/typesense/page';
import getImgUrl from '../utils/getImageUrl';

export default TaxonomyItemPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const defaultSortBy = TSTaxonomy.sortOptions[6]; // on sale page default sort by is newest
  const pageData = await TSPage.getBySlug('gift-baskets-on-sale');

  const defaultQueryVars: ITSTaxonomyProductQueryVars =
    TSTaxonomy.getDefaultTsQueryVars();
  const taxonomyProductQueryVars: ITSTaxonomyProductQueryVars = {
    ...defaultQueryVars,
    sortBy: defaultSortBy?.value as string,
    onSale: true,
  };

  const tsFetchedData = await TSTaxonomy.getProducts(taxonomyProductQueryVars);

  return {
    props: {
      fullHead: pageData?.seoFullHead,
      pageSchemaCode: pageData?.pageSchemaCode ?? '',
      categoryName: pageData?.name,
      popular: [],
      hero: {
        name: pageData?.name,
        sourceUrl: pageData?.thumbnail?.src,
      },
      tsFetchedData: tsFetchedData,
      topDescription:
        'These beautiful gift baskets are now at clearance prices as we make way for our new 2024 ranges! Search our gift hampers on sale to find real value and a stunning gift basket presented with our Gourmet Basket Signature Packaging. Delivery Australia-wide. Available while stocks last!',
      defaultSortBy: defaultSortBy,
    },
    revalidate: 43200, // Refresh the generated page every 12 hours,
  };
};
